import { useCallback, useState } from 'react';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

import { RadiusConfig } from 'enable-ui';

import { InputPhoneContainer, InvalidPhoneMessage } from './styles';

import type { InputPhoneProps } from './type';

import { validatePhoneNumber } from 'helpers';

import { COLOR, COLOR_CONFIG } from 'constants/color';

import { InputTitle } from './InputTitle';

export const InputPhone: React.FC<InputPhoneProps> = ({
  value,
  onChange,
  placeholder,
  title,
  required,
  disabled,
}) => {
  const [isTouched, setIsTouched] = useState(false);
  const [invalidPhone, setInvalidPhone] = useState<string | null>(null);

  const handleChange = useCallback(
    (newValue: string | undefined) => {
      if (!isTouched) setIsTouched(true);

      const validationError = validatePhoneNumber(newValue || '', 'SG');

      setInvalidPhone(validationError);
      onChange(newValue || '');
    },
    [isTouched, onChange],
  );

  const getBorderColor = () => {
    if (!isTouched) return COLOR.neutralTrans['neutralTrans-15'];
    if (invalidPhone) return COLOR_CONFIG.red;
    if (value) return COLOR.green['green-7'];

    return COLOR.primary['primary-6'];
  };

  const phoneInputStyle = {
    padding: '8px',
    borderRadius: `${RadiusConfig.xs}px`,
    border: `1px solid ${getBorderColor()}`,
  };

  return (
    <InputPhoneContainer direction="column" is_disabled={disabled || false}>
      <InputTitle title={title} required={required} />
      <PhoneInput
        disabled={disabled}
        placeholder={placeholder}
        value={value || ''}
        onChange={handleChange}
        defaultCountry="SG"
        countryCallingCodeEditable={false}
        international={false}
        countries={['SG']}
        style={phoneInputStyle}
      />
      {isTouched && invalidPhone && <InvalidPhoneMessage>{invalidPhone}</InvalidPhoneMessage>}
    </InputPhoneContainer>
  );
};
